import { posAxiosClient } from '@kinderlabs-pos/apis/axios';

export const getPosPrinterModelListAsync = (rootUrl: string) => async () =>
	(await posAxiosClient.get<string[]>(`${rootUrl}/store/pos/hardware/model`)).data;
